import React, { useState, useEffect } from "react";
import { CiSearch } from "react-icons/ci";
import { RiSave2Fill } from "react-icons/ri";
import { BsCheck2 } from "react-icons/bs";
import { TbArrowBackUp } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { API_HOST } from "../../api_utils";
import "./customerStyles.css";
import {
  Autocomplete,
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

import { MdOutlineKeyboardBackspace } from "react-icons/md";

function CustomerDetailNickname(props) {
  let navigate = useNavigate();

  const [showCustomerForm, setShowCustomerForm] = useState(false);
  const [agentName, setAgentName] = useState("");
  const [agentId, setAgentId] = useState("");
  const [agentManagerData, setAgentManagerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customHeadFromApi, setCustomerHeadFromApi] = useState({});
  const [agentNameFilter, setAgentNameFilter] = useState("");
  const [customerHeadAndAgentData, setCustomerHeadAndAgentData] = useState([]);
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");

  const { userDataFromStorage, coloredTheme } = props;

  const { customerHeadData } = useSelector(
    (state) => state.addCustomerHeadData
  );

  const [addCustomerData, setAddCustomerData] = useState({
    agent_id: "",
    customer_header_name: "",
    nickname: "",
    address: "",
    mobile_number: "",
    pay_customer_stamp: true,
    phone_2: "",
    phone_3: "",
    phone_4: "",
    post_code: "",
    state: "",
  });

  const [customerHeadDataFromParam, setCustomerHeadDataFromParam] =
    useState("");

  const [searchParams] = useSearchParams();
  const customerIdFromParams = searchParams.get("customerId");

  const [addCustomerLoading, setAddCustomerLoading] = useState(false);

  console.log("customerId", customerIdFromParams);

  const getAgentManagerApi = async () => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${userDataFromStorage.token}`,
        "Content-Type": "application/json",
      },
    };

    console.log("config", config);

    const { data } = await axios.get(
      `${API_HOST}/api/users/user_manager_relation/`,
      config
    );

    if (data) {
      setLoading(false);
      setAgentManagerData(data);
    } else {
      setLoading(false);
      toast.error(data.message);
    }
  };

  const getCustomerHeadFromParamApi = async (customerHeadId) => {
    let url = `${API_HOST}/api/customer_head/customer_header_list`;
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    console.log("config", config);

    const { data } = await axios.get(url, config);

    if (data) {
      let dataMod = data.find(
        (user) => user.id_number === parseInt(customerHeadId)
      );
      if (dataMod) {
        console.log("dataMod::::::::", dataMod);
        setCustomerHeadDataFromParam(dataMod);
      }
    } else {
      toast.error(data.message);
    }
  };

  const getCustomerHeadApi = async (customerHeadId) => {
    setLoading(true);
    const config = {
      "Content-Type": "application/json",
    };

    let apiUrl = `${API_HOST}/api/customer/customer_head/${customerHeadId}`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setCustomerMobileNumber(data[0].mobile_number);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    let customerHeadId = window.location.href.split("=")[1];
    console.log("customerHeadId", customerHeadId);
    if (customerHeadId) {
      getCustomerHeadFromParamApi(customerHeadId);
      getCustomerHeadApi(customerHeadId);
    }
  }, []);

  useEffect(() => {
    getAgentManagerApi();
  }, []);

  const addCustomerHandler = async () => {
    if (addCustomerData.nickname) {
      if (
        addCustomerData.pay_customer_stamp === true ||
        addCustomerData.pay_customer_stamp === false
      ) {
        if (addCustomerData.mobile_number) {
          // const mobileNumberRegex = /^\d{7}$/;

          if (addCustomerData.mobile_number.length > 7) {
            setAddCustomerLoading(true);
            const config = {
              headers: {
                "Content-Type": "application/json",
              },
            };

            const { data } = await axios.post(
              `${API_HOST}/api/customer/add_cutomer`,
              addCustomerData,
              config
            );
            if (data) {
              if (data.message) {
                setAddCustomerLoading(false);
                toast.error(data.message);
              } else {
                setAddCustomerLoading(false);
                toast.success("Customer Added Successfully !!!");
                navigate("/customers/overview");
              }
            } else {
              toast.error("Something Went Wrong !!!");
            }
          } else {
            toast.warn("Please provide a valid mobile number !!!");
          }
        } else {
          toast.warn("Please provide a valid mobile number !!!");
        }
      } else {
        toast.warn("Please select a value for Pay Customer Stamp field!!!");
      }
    } else {
      toast.warn("Make Sure to Fill All Fields");
    }
  };

  const stateList = [
    {
      name: "Johor",
      id: 1,
    },
    {
      name: "Kedah",
      id: 2,
    },
    {
      name: "Kelantan",
      id: 3,
    },
    {
      name: "Negeri Semibilan",
      id: 4,
    },
    {
      name: "Pahang",
      id: 5,
    },
    {
      name: "Penang",
      id: 6,
    },
    {
      name: "Perak",
      id: 7,
    },
    {
      name: "Perlis",
      id: 8,
    },
    {
      name: "Sabah",
      id: 9,
    },
    {
      name: "Sarawak",
      id: 10,
    },
    {
      name: "Selangor",
      id: 11,
    },
    {
      name: "Terrenganu",
      id: 12,
    },
    {
      name: "Wilayah Persekutuan",
      id: 13,
    },
  ];

  // get customer head data by customer id from search params:

  const customerHeaderApiCallUsingSearchParams = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const customerIdCheckPayload = {
      customerId_check_variable: parseInt(
        customerIdFromParams.replace(/-/g, "")
      ),
    };
    const { data } = await axios.post(
      `${API_HOST}/api/customer_head/check_head_id`,
      customerIdCheckPayload,
      config
    );

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setCustomerHeadFromApi(data);
      setShowCustomerForm(true);
    }
  };

  useEffect(() => {
    if (customerIdFromParams && customerIdFromParams !== null) {
      customerHeaderApiCallUsingSearchParams();
    }

    if (!agentNameFilter) {
      getAgentManagerApi();
    }
  }, [agentNameFilter]);

  const filterUserManagerList = () => {
    console.log("agentNameFilter", agentNameFilter);
    if (agentNameFilter) {
      console.log("agentManagerData", agentManagerData);
      const result = agentManagerData.filter((x) => {
        if (typeof x.agent !== "undefined") {
          return x.agent.toLowerCase().includes(agentNameFilter.toLowerCase());
        }
        return false; // If x.agent is undefined, include the item in the result
      });
      setAgentManagerData(result);
    } else {
      toast.warn("Please Enter Agent Name !!!");
    }
  };

  // useEffect(() => {
  //   if (customerMobileNumber) {
  //     setAddCustomerData((prevState) => ({
  //       ...prevState,
  //       mobile_number: customerMobileNumber,
  //     }));
  //   }
  // }, [customerMobileNumber]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <div className="flex justify-start items-center space-x-4">
        {/* <p
          onClick={() => navigate("/customers/detail_id")}
          className="text-[2.3rem] text-gray-700 hover:text-gray-300 transition duration-[0.5s]">
          <MdOutlineKeyboardBackspace />
        </p> */}
        <p className="text-gray-800 text-[1.8rem] tracking-wider">
          Nickname Detail
        </p>
      </div>
      <div
        className={
          showCustomerForm
            ? "hidden"
            : userDataFromStorage.user_role === "agent" ||
              userDataFromStorage.user_role === "senior_agent"
            ? "hidden"
            : `flex justify-start items-center space-x-4 mt-4`
        }>
        <input
          value={agentNameFilter}
          onChange={(e) => setAgentNameFilter(e.target.value)}
          type="text"
          id="idCheckCustomer"
          className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
          placeholder="Enter Name Of Agent Who Will Manage This Customer"
        />
        <button
          onClick={() => filterUserManagerList()}
          style={{ backgroundColor: coloredTheme }}
          className="flex justify-center items-center space-x-2  text-green-50  hover:bg-green-50  hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded ">
          <CiSearch className="text-2xl " />
          <span>Search</span>
        </button>
      </div>

      <div className="mt-16 overflow-scroll ">
        {/* Render Table If Customer Exists */}
        {!showCustomerForm &&
        userDataFromStorage.user_role !== "agent" &&
        userDataFromStorage.user_role !== "senior_agent" ? (
          <table className="md:w-[100%] w-[350%]">
            <thead className="h-[5vh]">
              <tr>
                <th className="text-start">Manager</th>
                <th className="text-start">Agent</th>
                <th className="text-start">Agent Mobile Number</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {agentManagerData.length &&
                agentManagerData.map((x) => (
                  <tr className="h-[5vh] bg-white ">
                    <td className={x.manager ? "" : "text-center"}>
                      {x.manager ? x.manager : "---"}
                    </td>
                    <td>{x.agent}</td>
                    <td>{x.mobile_number ? x.mobile_number : "---"}</td>
                    <td className=" flex justify-end">
                      <button
                        onClick={() => {
                          setAgentName(x.agent);
                          setAgentId(x.employee_number);
                          setShowCustomerForm(true);
                        }}
                        style={{ backgroundColor: coloredTheme }}
                        className="flex justify-center items-center space-x-2  text-orange-50  hover:bg-orange-50 hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded ">
                        <BsCheck2 className="text-xl " />
                        <span>Select</span>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <div className="bg-white p-[0.8rem]">
            {addCustomerLoading ? (
              <div class="loading-wave">
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
                <div class="loading-bar"></div>
              </div>
            ) : (
              <>
                <div className="flex justify-start items-center font-Roboto  ">
                  <p className="text-gray-700 w-[15rem]">Customer</p>
                  <p className="p-[0.5rem]">
                    {customerHeadDataFromParam
                      ? customerHeadDataFromParam.customer_name
                      : customerHeadData
                      ? customerHeadData.customer_name
                      : customHeadFromApi
                      ? customHeadFromApi?.customer_name
                      : ""}
                  </p>
                </div>
                <div className="flex justify-start items-center font-Roboto mt-2">
                  <p className="text-gray-700 w-[15rem]">Agent</p>
                  <p className="p-[0.5rem]">
                    {userDataFromStorage.user_role === "agent" ||
                    userDataFromStorage.user_role === "senior_agent"
                      ? userDataFromStorage.last_name
                      : agentName
                      ? agentName
                      : userDataFromStorage?.full_name}
                  </p>
                </div>

                <div className="flex justify-start items-center font-Roboto  mt-2">
                  <label htmlFor="mob" className="text-gray-700 w-[15rem]">
                    Mobile Number
                  </label>
                  <input
                    value={addCustomerData?.mobile_number}
                    id="mob"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                    placeholder="Enter Your Mobile Number "
                    onChange={(e) =>
                      setAddCustomerData((prevState) => ({
                        ...prevState,
                        mobile_number: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="flex justify-start items-center font-Roboto  mt-2">
                  <label htmlFor="nickname" className="text-gray-700 w-[15rem]">
                    Nickname
                  </label>
                  <input
                    onChange={(e) =>
                      setAddCustomerData((prevState) => {
                        return {
                          ...prevState,
                          nickname: e.target.value,
                          agent_id:
                            userDataFromStorage.user_role === "agent" ||
                            userDataFromStorage.user_role === "senior_agent"
                              ? userDataFromStorage.employee_number
                              : agentId,
                          customer_header_name: customerHeadDataFromParam
                            ? parseInt(customerHeadDataFromParam.id_number)
                            : customerHeadData
                            ? parseInt(customerHeadData.id_number)
                            : customHeadFromApi
                            ? parseInt(customHeadFromApi.id_number)
                            : "",
                        };
                      })
                    }
                    id="nickname"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                    placeholder="Enter Your Nickname "
                  />
                </div>

                <div className="flex justify-start items-center font-Roboto mt-2">
                  <label htmlFor="mob2" className="text-gray-700 w-[15rem]">
                    Phone No 2
                  </label>
                  <input
                    onChange={(e) =>
                      setAddCustomerData((prevState) => ({
                        ...prevState,
                        phone_2: e.target.value,
                      }))
                    }
                    id="mob2"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                    placeholder="Enter Your Phone Number 2 "
                  />
                </div>
                <div className="flex justify-start items-center font-Roboto mt-2">
                  <label htmlFor="mob3" className="text-gray-700 w-[15rem]">
                    Phone No 3
                  </label>
                  <input
                    onChange={(e) =>
                      setAddCustomerData((prevState) => ({
                        ...prevState,
                        phone_3: e.target.value,
                      }))
                    }
                    id="mob3"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                    placeholder="Enter Your Phone Number 3 "
                  />
                </div>
                <div className="flex justify-start items-center font-Roboto mt-2">
                  <label htmlFor="mob4" className="text-gray-700 w-[15rem]">
                    Phone No 4
                  </label>
                  <input
                    onChange={(e) =>
                      setAddCustomerData((prevState) => ({
                        ...prevState,
                        phone_4: e.target.value,
                      }))
                    }
                    id="mob4"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                    placeholder="Enter Your Phone Number 4 "
                  />
                </div>
                <div className="flex justify-start items-center font-Roboto  mt-2">
                  <label htmlFor="address" className="text-gray-700 w-[15rem]">
                    Address
                  </label>
                  <input
                    onChange={(e) =>
                      setAddCustomerData((prevState) => ({
                        ...prevState,
                        address: e.target.value,
                      }))
                    }
                    id="address"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                    placeholder="Enter Your Address"
                  />
                </div>
                <div className="flex justify-start items-center font-Roboto  mt-2">
                  <label htmlFor="postCode" className="text-gray-700 w-[15rem]">
                    PostCode
                  </label>
                  <input
                    onChange={(e) =>
                      setAddCustomerData((prevState) => ({
                        ...prevState,
                        post_code: e.target.value,
                      }))
                    }
                    id="postCode"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none"
                    placeholder="Enter Your Postal Code"
                  />
                </div>
                <div className="flex justify-start items-center  mt-2">
                  <label htmlFor="state" className=" text-gray-700  w-[15rem]">
                    State
                  </label>
                  <select
                    value={addCustomerData.state}
                    onChange={(e) =>
                      setAddCustomerData((prevState) => ({
                        ...prevState,
                        state: e.target.value,
                      }))
                    }
                    id="state"
                    className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]">
                    <option>Select A State</option>
                    {stateList.map((x) => (
                      <option key={x._id} value={x.name}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex justify-start items-center font-Roboto mt-2">
                  <p className="text-gray-700 w-[15rem]">Pay Customer Stamp</p>
                  {/* <select
                
                id="customerStamp"
                className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none">
                <option value="none">Choose An Option</option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select> */}
                  <div className="flex space-x-[2rem] items-center">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={addCustomerData?.pay_customer_stamp}
                        name="radio-buttons-group"
                        onChange={(e) =>
                          setAddCustomerData((prevState) => ({
                            ...prevState,
                            pay_customer_stamp: e.target.value,
                          }))
                        }
                        row>
                        <FormControlLabel
                          value={true}
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value={false}
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="flex justify-start items-center space-x-4 mt-8 mb-8">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={addCustomerHandler}
                    className="flex justify-center items-center space-x-2   text-purple-50 px-[1rem] py-[0.5rem] rounded  hover:bg-purple-50  hover:shadow-2xl hover:shadow-black">
                    <RiSave2Fill className="text-2xl" />
                    <p>Save</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => navigate("/customers/detail_id")}
                    className="flex justify-center  items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50  hover:shadow-2xl hover:shadow-black ">
                    <TbArrowBackUp className="text-2xl" />
                    <p>Cancel</p>
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default CustomerDetailNickname;
